export enum ChatChannelKind {
  EXTERNAL = 'external',
  INTERNAL = 'internal',
  SUPPORT = 'support'
}



// WEBPACK FOOTER //
// ./src/models/chatChannelModel/types.ts